import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { INamedItem } from '../../../ts/ServerApi/types/resourceParts';
import { IPublishedConnectionTable } from '../types/IPublishedConnectionTable';

export interface IGetPublishedConnectionTablesParams extends IGetItemsParams {
}

export interface IGetPublishedConnectionTablesResult extends IGetItemsResult {
  publishedConnectionTables?: IPublishedConnectionTable[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetPublishedConnectionTablesRequest extends Request<IGetPublishedConnectionTablesParams, IGetPublishedConnectionTablesResult> {
  constructor(params: IGetPublishedConnectionTablesParams) {
    super('getPublishedConnectionTables', params);
  }
}
